import { JSX, ReactNode, useState } from 'react'

import { Flex, Image, Spinner, ImageProps } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request.js'

import * as detective from '@/lib/detective.js'

import * as contract_storage from '@/storage/contract.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Toast from '@/components/ui/toast.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'


import icon from '/public/images/ui/mimetype/PDF.png'




export default function
(
	props: {
		doc: HttpBody<contract_storage.TRawDocumentType>

		update(name: string, value: unknown): void
		refresh(): void

	},

)
:	JSX.Element
{
	let { _id, name, signature, agreement } = props.doc

	let on_create = async (): Promise<void> =>
	{
		try
		{
			await contract_storage.create_agreement(_id)

		}
		catch (e)
		{
			Toast.error(e as Error)

		}

		props.refresh?.()

	}

	let on_update = (name_: string, value: unknown): void =>
	{
		props.update(name_, value)

	}

	let on_download = async (src: string): Promise<void> =>
	{
		await download(src, `${name}.pdf`)

	}


	return (
		<Fieldset.Root divide name="员工合同">
			<Fieldset.Group>
				<Field.Image label="员工签名" name="signature" thumbnail={signature} change={on_update} />

			</Fieldset.Group>

			<Fieldset.Group columns={[1]}>
				<Agreement label="合同条款" name="agreement" value={agreement} create={on_create} download={on_download} />

			</Fieldset.Group>

		</Fieldset.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Agreement
(
	props: {
		label: string
		name : string
		value: string[]

		create(): Promise<void>
		download(src: string): Promise<void>

	},

)
:	JSX.Element
{
	let [loading, update_loading] = useState('')

	let on_create = async (): Promise<void> =>
	{
		if (detective.is_required_string(loading) )
		{
			return

		}

		update_loading('create')

		await props.create()

		update_loading('')

	}

	let on_download = async (src: string): Promise<void> =>
	{
		if (detective.is_required_string(loading) )
		{
			return

		}

		update_loading(src)

		await props.download(src)

		update_loading('')

	}

	let items = props.value
		.map(
			v => <Box key={v} loading={loading === v} click={() => on_download(v)} />,

		)

	return (
		<Field.Root {...props} value={props.value.join('\n')}>
			<Flex p="1" gap="6" flexWrap="wrap">
				{items}

				<Box key="create" loading={loading === 'create'} click={on_create}>
					<Icon opacity={0.32} />

				</Box>

			</Flex>

		</Field.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Icon
(props: ImageProps): JSX.Element
{
	return (
		<Image {...props} src={icon} />

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Box
(
	props: {
		loading  : boolean
		children?: ReactNode

		click?(): void

	},

)
:	JSX.Element
{
	let on_click = (): void =>
	{
		props.click?.()

	}

	return (
		<Flex
			h="24"
			w="24"
			p="2"
			rounded="md"
			cursor="pointer"
			position="relative"
			justifyContent="center"
			alignItems="center"
			_hover={{ bg: 'bg.muted' }}
			onClick={on_click}
		>
			{props.children ?? <Icon />}

			{props.loading && <Spinner position="absolute" color="blue.solid" />}

		</Flex>

	)

}


export async function download
(src: string, filename: string): Promise<void>
{
	let h = await fetch(src)

	let blob = await h.blob()

	let url = URL.createObjectURL(blob)

	let anchor = document.createElement('a')

	anchor.href = url
	anchor.download = filename
	anchor.click()

	URL.revokeObjectURL(url)


}
